module.exports = __webpack_public_path__ + "img/card_bg3.9306d115.png";